import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { SavingsSection } from '../components/SavingsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { LegalModal } from '../components/LegalModal';
type LegalType = 'privacy' | 'terms' | null;
export function SalesPage() {
  const [legalOpen, setLegalOpen] = useState<LegalType>(null);
  return <div className="min-h-screen bg-warm-white font-sans text-espresso selection:bg-terracotta selection:text-white" data-id="element-174">
      <nav className="absolute top-0 left-0 w-full p-6 z-40" data-id="element-175">
        <div className="container mx-auto flex justify-between items-center" data-id="element-176">
          <span className="text-2xl font-serif font-bold text-espresso tracking-tight" data-id="element-177">
            3 Bases <span className="text-terracotta" data-id="element-178">15 Platos</span>
          </span>
        </div>
      </nav>

      <main data-id="element-179">
        <HeroSection data-id="element-180" />
        <PainSection data-id="element-181" />
        <MechanismSection data-id="element-182" />
        <WhatInsideSection data-id="element-183" />
        <SavingsSection data-id="element-184" />
        <CTASection data-id="element-185" />
      </main>

      <Footer onOpenPrivacy={() => setLegalOpen('privacy')} onOpenTerms={() => setLegalOpen('terms')} data-id="element-186" />

      <LegalModal type={legalOpen} onClose={() => setLegalOpen(null)} data-id="element-187" />
    </div>;
}